import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export const inputCls = "mt-1.5 bg-[#0D0D0D] border-white/10 text-white focus-visible:ring-[#00C896]";

export function Field({ label, testid, ...props }) {
  return (
    <div>
      <Label className="text-slate-300 text-sm">{label}</Label>
      <Input data-testid={testid} className={inputCls} {...props} />
    </div>
  );
}

export function FormDialog({ open, onOpenChange, title, testid, children, onSave, saving, disabled, saveLabel = "Save" }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testid} className="bg-[#14181D] border-white/10 text-white w-[calc(100%-2rem)] max-w-md rounded-2xl sm:rounded-2xl">
        <DialogHeader><DialogTitle className="font-display">{title}</DialogTitle></DialogHeader>
        <div className="space-y-4 mt-2">
          {children}
          <Button data-testid={`${testid}-save`} onClick={onSave} disabled={saving || disabled} className="w-full rounded-xl bg-[#00C896] hover:bg-[#00E5AC] text-[#04140D] font-semibold">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : saveLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function CardHead({ icon: Icon, title, sub, action }) {
  return (
    <div className="flex items-start justify-between gap-3">
      <div className="flex items-center gap-2.5 min-w-0">
        <span className="h-10 w-10 rounded-xl bg-[#00C896]/15 flex items-center justify-center text-[#00C896] shrink-0"><Icon className="h-5 w-5" /></span>
        <div className="min-w-0">
          <h3 className="font-display text-lg font-semibold">{title}</h3>
          {sub && <p className="text-xs text-slate-500">{sub}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}

export const ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const niceDate = (iso) => new Date(iso).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
